import React, { useEffect, useState } from "react";
import { createActivity, createBook } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddActivity = ({ data, onClose, onCloseWithApi }) => {
  const [reqData, setReqData] = useState({
    name: "",
    description: "", 
    id: "",
  });
  const [loader, setLoader] = useState(false);

  const handleChange = (field, value) => {
    setReqData({ ...reqData, [field]: value })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    let { ok } = await createActivity(reqData);
    if (ok) {
      toast.success("Success");
      onCloseWithApi();
    }
    setLoader(false);
  };

  useEffect(() => {
    if (data?.data) {
      const { name, description, id } = data?.data;
      setReqData({ name, description, id })
    }
  }, []);

  return (
    <div
      className="modal custom-modal fade bank-details show"
      id="add_items"
      role="dialog"
      aria-modal="true"
      style={{
        display: "block",
        background: "rgb(0 0 0 / 50%)",
      }}
    >
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <div className="form-header text-start mb-0">
                <h4 className="mb-0">{!reqData?.id ? "Add Activity" : "Edit Activity"}</h4>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => onClose()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="bank-inner-details">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={reqData?.name}
                        onChange={(e) => handleChange("name", e?.target?.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Description"
                        required
                        value={reqData?.description}
                        onChange={(e) => handleChange("description", e?.target?.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="bank-details-btn">
                <button
                  data-bs-dismiss="modal"
                  className="btn bank-cancel-btn me-2"
                  onClick={() => onClose()}
                  disabled={loader}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn bank-save-btn"
                  disabled={loader}
                >
                  {loader ? "Loading..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddActivity;